export const TEST_ID = 'drawingToolDropdown';
